import type { IgnoreModifier } from '@apollo/client/cache'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'
import { isOfType } from '~publish/helpers/typeGuards'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

const DeleteFeedCollection = graphql(/* GraphQL */ `
  mutation DeleteFeedCollection($input: DeleteFeedCollectionInput!) {
    deleteFeedCollection(input: $input) {
      __typename
      ... on FeedCollectionDeleteSuccess {
        feedCollectionId
      }
      ... on MutationError {
        message
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useDeleteFeedCollection = () =>
  useTypedMutation(DeleteFeedCollection, (data) => data.deleteFeedCollection, {
    successTypename: 'FeedCollectionDeleteSuccess',
    optimisticResponse: (
      variables,
      { IGNORE },
    ): ResultOf<typeof DeleteFeedCollection> | IgnoreModifier => {
      const { feedCollectionId } = variables.input
      if (!feedCollectionId) {
        return IGNORE
      }

      return {
        deleteFeedCollection: {
          __typename: 'FeedCollectionDeleteSuccess',
          feedCollectionId,
        },
      }
    },
    update(cache, { data }) {
      const result = data?.deleteFeedCollection
      if (isOfType(result, 'FeedCollectionDeleteSuccess')) {
        const normalizedId = cache.identify({
          id: result.feedCollectionId,
          __typename: 'FeedCollection',
        })
        cache.evict({ id: normalizedId })
        cache.gc()
      }
    },
  })
